import REUAlumni_2021 from '../../assets/Image/REUAlumni_2021.jpg';

export const REU_A_2021 = (
    <div>
        <p className="title"><b>2021 REU Alumni</b></p>
        <img className="img-fluid" src={REUAlumni_2021} alt="Image" />
        <p>

            <br /><br />
            At the end of the program, each REU student made a presentation at the 2021 UC San Diego Summer Research Conference, summarizing their respective research projects and accomplishments to include lessons learned.
            <br /><br />
            SDNI anticipates that all participants will share their unique and exciting hands-on research experience and other components of the program to include presentation skills and the writing of a personal statement with several students at their respective colleges, and by doing so will promote STEM and more specifically nanotechnology education.
            <br /><br />
            <b>The participants’ final presentations can be found below.</b>
            <br /><br />
            <a href="https://drive.google.com/drive/folders/1WvEch3otnf2rOrHsUgSkjfvoLnz5Jfs4?usp=sharing"><button className="programs-button">REU Final Presentation</button></a>
            <br /><br /><br /><br /><br />
        </p>
    </div>
)